@if (isReady) {
  <div class="wrapper" [class.chain-admin]="isChainAdmin()">
    <div class="header-wrapper">
      <div class="dummy"></div>
      <div class="header">
        <div class="dummy"></div>

        <div class="header-content">
          <h1>select customer</h1>

          <div class="actions">
            <div class="filter">
              <div class='search-box-wrapper'>
                <input class="search-box" (focusin)="onFocus()" [ngModel]="searchString" (input)="onInputChange($event)" placeholder="{{'COMMON.SEARCH' | translate}}" #input />
              </div>

              <div class="checkboxes">
                @if (showToggleExPartners()) {
                  <checkbox (checkedChange)="ToggleExPartners($event)" [checked]="showExPartners" [label]="'CUSTOMERS.FILTER-CUSTOMERS' | translate"></checkbox>
                }

                @if (showTogglePreciousPartners()) {
                  <checkbox (checkedChange)="TogglePreciousPartners($event)" [checked]="showPreciousPartners" [label]="'CUSTOMERS.PRECIOUS-ONLY' | translate"></checkbox>
                }
              </div>
            </div>

            @if (newCustomerModuleEnabled) {
              <div class="loadingShopInfo">
                @if (isDoingShopInfoLookup) {
                  <div class="xlight">
                    {{'NEW.PARTNER.CHECKSHOPINFO' | translate}}
                  </div>
                }
                @else {
                <div class="pointer" (click)="shopInfoLookup()">
                  <span class="fa-light fa-arrows-rotate lead-icon"></span>&nbsp;{{'NEW.PARTNER.UPDATEACCOUNTLIST' | translate}}
                </div>
              }
            </div>
          }
        </div>

        @if (showExPartners) {
          <div>
            <div class="toggles">
              <div class="toggles-column">
                <cstmsr-toggle [disabled]="showPreciousPartners" [on]="showActiveCustomers" [color]="'#456E57'" (valueChanged)="toggleCustomerType($event, customerStatusEnum.active)">
                  {{ 'CUSTOMERS.ACTIVE-CUSTOMERS' | translate }}
                </cstmsr-toggle>
                <cstmsr-toggle [disabled]="showPreciousPartners" [on]="showNonPartnerCustomers" [color]="'#E2BE3F'" (valueChanged)="toggleCustomerType($event, customerStatusEnum.nonPartner)">
                  <span class="inactive-toggle-long">
                    {{ 'CUSTOMERS.INACTIVE-CUSTOMERS-LONG' | translate }}
                  </span>
                  <span class="inactive-toggle-short">
                    {{ 'CUSTOMERS.INACTIVE-CUSTOMERS-SHORT' | translate }}
                  </span>
                </cstmsr-toggle>
              </div>
              <div class="toggles-column">
                <cstmsr-toggle [disabled]="showPreciousPartners" [on]="showBlockedCustomers" [color]="'#D36B41'" (valueChanged)="toggleCustomerType($event, customerStatusEnum.blocked)">
                  {{ 'CUSTOMERS.CLOSED-CUSTOMERS' | translate }}
                </cstmsr-toggle>
                <cstmsr-toggle [disabled]="showPreciousPartners" [on]="showNonDistributedCustomers" [color]="'#6FC9E3'" (valueChanged)="toggleCustomerType($event, customerStatusEnum.nonDistributed)">
                  {{ 'CUSTOMERS.NON-LINDBERG-CUSTOMERS' | translate }}
                </cstmsr-toggle>
              </div>
            </div>
          </div>
        }

        <div class="cst-tabs">
          <cstmsr-tab-container [tabs]="tabs" [activeTab]="activeTab" [useMargin]="false" [mini]="toggleMini" (activeTabChanged)="activateTab($event)" />
        </div>
      </div>
      <div class="dummy"></div>
    </div>

    <div class="dummy"></div>
  </div>

  <div class="content" infiniteScroll [infiniteScrollDistance]="0" [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrollDown()">
    @if (activeTab.name === CustomerSelectorTabNameOptions.my) {
      <div class="tab">
        <div class="customer">
          <div class="partner-content pointer" (click)="onSelect(null)">
            <div class="partner-name-no-address">
              {{user?.canOrderOnBehalf && !user?.IsDistributor ? ('CUSTOMERS.TEST-FOR' | translate: {'name': $safeNavigationMigration(user?.Name)}) : user?.Name}}
            </div>
          </div>
        </div>

        @for (partner of customersOwnDistrict$ |async; track partner.Name+partner.No) {

          <div class="customer">
            <div class="partner-content pointer" (click)="onSelect(partner)">
              <div class="partner-name-no-address">
                <div class="partner-name-no">
                  <div class="bullet-name">
                    @if (showExPartners) {
                      <div class="bullet" [ngClass]="partner.Status">&nbsp;</div>
                    }

                    <div>
                      {{partner.Name}}
                    </div>
                  </div>
                  <div class="partner-no">
                    {{partner?.Code}}
                  </div>
                </div>
                <div class="partner-address" [ngClass]="{'bullet': showExPartners}">
                  {{partner.AddressStringified2}}
                </div>
              </div>

              @if (partner.ShowBrands) {
                <div class="partner-brands">
                  <b class="brands-header">{{ 'CUSTOMERS.KERING-EYEWEAR-BRANDS' | translate }}</b>

                  <div>
                    {{partner.KeringEyewearBrands}}
                  </div>
                </div>
              }
            </div>

            <div class="customer-actions">
              @if (user?.AdminOnChain && (isLoadingOrderIds(partner) || hasOpenOrders(partner))) {
                <icon-bag class="admin-chain-bag-icon" [showSpinner]="isLoadingOrderIds(partner)"/>
              }
              @if (!partner.ShowBrands) {
                <button class="expand-button" (click)="toggleBrands($index, true)">
                  <span class="mr-1">{{ 'CUSTOMERS.INFO' | translate }}</span>
                  <i class="fa-light fa-angle-down input-arrow arrow"></i>
                </button>
              }
              @else {
              <button class="expand-button" (click)="toggleBrands($index, true)">
                <span class="mr-1">{{ 'COMMON.CLOSE' | translate }}</span>
                <i class="fa-light fa-xmark"></i>
              </button>
            }
          </div>
        </div>

      }

    </div>

  }
  @else if (activeTab.name === CustomerSelectorTabNameOptions.other) {

  <div class="tab">
    @if (shopInfoCustomers?.length === 0) {
      <div class="no-leads">
        {{'NEW.PARTNER.NOACCOUNTSWEREFOUND' | translate}}
      </div>
    }

    <!-- <div *ngIf="customersOtherDistricts$ && customersOtherDistricts$.value.length" class="list-group">
    <ng-container *ngFor="let partner of customersOtherDistricts$ | async; let index = index">
      <div class="customer">
        <div class="partner-content pointer" (click)="onSelect(partner)">
          <div class="partner-name-no">
            <div class="bullet-name">
              <div *ngIf="showExPartners" class="bullet" [ngClass]="partner.Status">&nbsp;</div>
              <div>
                {{partner.Name}}
              </div>
            </div>
            <div>
              {{partner?.Code}}
            </div>
          </div>
          <div class="partner-address">
            {{partner.AddressStringified2}}
          </div>
          <div class="partner-brands" *ngIf="partner.ShowBrands">
            <b class="brands-header">{{ 'CUSTOMERS.KERING-EYEWEAR-BRANDS' | translate }}
            </b>
            <div>
              {{partner.KeringEyewearBrands}}
            </div>
          </div>
        </div>
        <button *ngIf="!partner.ShowBrands" class="expand-button" (click)="toggleBrands(index, false)">
          <span class="mr-1">{{ 'CUSTOMERS.INFO' | translate }}</span>
          <i class="fa-light fa-angle-down input-arrow arrow"></i>
        </button>
        <button *ngIf="partner.ShowBrands" class="expand-button" (click)="toggleBrands(index, false)">
          <span class="mr-1">{{ 'COMMON.CLOSE' | translate }}</span>
          <i class="fa-light fa-xmark"></i>
        </button>
      </div>
    </ng-container>
  </div> -->

  @for (partner of customersOtherDistricts$ | async; track $index) {

    <div class="customer">
      <div class="partner-content pointer" (click)="onSelect(partner)">
        <div class="partner-name-no-address">
          <div class="partner-name-no">
            <div class="bullet-name">
              @if (showExPartners) {
                <div class="bullet" [ngClass]="partner.Status">&nbsp;</div>
              }

              <div>
                {{partner.Name}}
              </div>
            </div>
            <div class="partner-no">
              {{partner?.Code}}
            </div>
          </div>
          <div class="partner-address" [ngClass]="{'bullet': showExPartners}">
            {{partner.AddressStringified2}}
          </div>
        </div>

        @if (partner.ShowBrands) {
          <div class="partner-brands">
            <b class="brands-header">{{ 'CUSTOMERS.KERING-EYEWEAR-BRANDS' | translate }}</b>

            <div>
              {{partner.KeringEyewearBrands}}
            </div>
          </div>
        }
      </div>

      <div class="customer-actions">
        @if (user?.AdminOnChain && (isLoadingOrderIds(partner) || hasOpenOrders(partner))) {
          <icon-bag class="admin-chain-bag-icon" [showSpinner]="isLoadingOrderIds(partner)"></icon-bag>
        }
        @if (!partner.ShowBrands) {
          <button class="expand-button" (click)="toggleBrands($index, false)">
            <span class="mr-1">{{ 'CUSTOMERS.INFO' | translate }}</span>
            <i class="fa-light fa-angle-down input-arrow arrow"></i>
          </button>
        }
        @else {
        <button class="expand-button" (click)="toggleBrands($index, false)">
          <span class="mr-1">{{ 'COMMON.CLOSE' | translate }}</span>
          <i class="fa-light fa-xmark"></i>
        </button>
      }
    </div>
  </div>

}

</div>

}

<!-- ### NON PARTNERS ### -->

@else if (activeTab.name === CustomerSelectorTabNameOptions.leads) {

<div class="tab">

  @if (!isDoingShopInfoLookup && shopInfoCustomers && shopInfoCustomers.length > 0) {
    <div class="shopinfo-list">
      @for (partner of shopInfoCustomers; track partner; let index = $index) {
        <div class="shopinfo-list-row"  (click)="onSelect(partner)">
          <div class="shopinfo-list-column">
            + {{partner.Name}}
          </div>
          <div class="shopinfo-list-column">
            {{partner?.No}}
          </div>
          <div class="shopinfo-list-column">
            {{partner.Address}}
          </div>
        </div>
      }
    </div>
  }

  @if (!isDoingShopInfoLookup && !shopInfoCustomers || (shopInfoCustomers && shopInfoCustomers.length === 0)) {
    <div class="none-found">
      <div class="fullrow mb-4">
        <em>{{'NEW.PARTNER.NOACCOUNTSWEREFOUND' | translate}}</em>
      </div>
    </div>
  }

</div>

}

</div>

</div>
}